/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Divider,
  Flex,
  Grid,
  Heading,
  Text,
  TextAreaField,
  TextField,
} from "@aws-amplify/ui-react";
import { GovernanceData } from "../models";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { DataStore } from "aws-amplify/datastore";
export default function GovernanceDataGovernanceOversightActivitiesUpdateForm(
  props
) {
  const {
    id: idProp,
    governanceData: governanceDataModelProp,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    GovernanceDataName: "",
    GovernanceDataDescription: "",
  };
  const [GovernanceDataName, setGovernanceDataName] = React.useState(
    initialValues.GovernanceDataName
  );
  const [GovernanceDataDescription, setGovernanceDataDescription] =
    React.useState(initialValues.GovernanceDataDescription);
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    const cleanValues = governanceDataRecord
      ? { ...initialValues, ...governanceDataRecord }
      : initialValues;
    setGovernanceDataName(cleanValues.GovernanceDataName);
    setGovernanceDataDescription(cleanValues.GovernanceDataDescription);
    setErrors({});
  };
  const [governanceDataRecord, setGovernanceDataRecord] = React.useState(
    governanceDataModelProp
  );
  React.useEffect(() => {
    const queryData = async () => {
      const record = idProp
        ? await DataStore.query(GovernanceData, idProp)
        : governanceDataModelProp;
      setGovernanceDataRecord(record);
    };
    queryData();
  }, [idProp, governanceDataModelProp]);
  React.useEffect(resetStateValues, [governanceDataRecord]);
  const validations = {
    GovernanceDataName: [],
    GovernanceDataDescription: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          GovernanceDataName,
          GovernanceDataDescription,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await DataStore.save(
            GovernanceData.copyOf(governanceDataRecord, (updated) => {
              Object.assign(updated, modelFields);
            })
          );
          if (onSuccess) {
            onSuccess(modelFields);
          }
        } catch (err) {
          if (onError) {
            onError(modelFields, err.message);
          }
        }
      }}
      {...getOverrideProps(
        overrides,
        "GovernanceDataGovernanceOversightActivitiesUpdateForm"
      )}
      {...rest}
    >
      <Heading
        level={4}
        children="Climate Governance Body Oversight Activities"
        {...getOverrideProps(overrides, "SectionalElement0")}
      ></Heading>
      <Heading
        children="NZCS1 paragraph 7b, 8a-d."
        {...getOverrideProps(overrides, "SectionalElement4")}
      ></Heading>
      <Text
        children="Update this record that describes the governance body’s oversight of climate-related risks and opportunities."
        {...getOverrideProps(overrides, "SectionalElement1")}
      ></Text>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement2")}
      ></Divider>
      <TextField
        label="Governance oversight activities record name Governance oversight activities record name (e.g. 2025 governance climate-related risk and opportunity oversight records)"
        isRequired={false}
        isReadOnly={false}
        value={GovernanceDataName}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              GovernanceDataName: value,
              GovernanceDataDescription,
            };
            const result = onChange(modelFields);
            value = result?.GovernanceDataName ?? value;
          }
          if (errors.GovernanceDataName?.hasError) {
            runValidationTasks("GovernanceDataName", value);
          }
          setGovernanceDataName(value);
        }}
        onBlur={() =>
          runValidationTasks("GovernanceDataName", GovernanceDataName)
        }
        errorMessage={errors.GovernanceDataName?.errorMessage}
        hasError={errors.GovernanceDataName?.hasError}
        {...getOverrideProps(overrides, "GovernanceDataName")}
      ></TextField>
      <Heading
        children="NZCS1 Paragraph 8b."
        {...getOverrideProps(overrides, "SectionalElement5")}
      ></Heading>
      <TextAreaField
        label="Describe how the governance body ensures availability of appropriate skills and competencies to provide oversight of climate-related risks and opportunities"
        isRequired={false}
        isReadOnly={false}
        value={GovernanceDataDescription}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              GovernanceDataName,
              GovernanceDataDescription: value,
            };
            const result = onChange(modelFields);
            value = result?.GovernanceDataDescription ?? value;
          }
          if (errors.GovernanceDataDescription?.hasError) {
            runValidationTasks("GovernanceDataDescription", value);
          }
          setGovernanceDataDescription(value);
        }}
        onBlur={() =>
          runValidationTasks(
            "GovernanceDataDescription",
            GovernanceDataDescription
          )
        }
        errorMessage={errors.GovernanceDataDescription?.errorMessage}
        hasError={errors.GovernanceDataDescription?.hasError}
        {...getOverrideProps(overrides, "GovernanceDataDescription")}
      ></TextAreaField>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement3")}
      ></Divider>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Reset"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          isDisabled={!(idProp || governanceDataModelProp)}
          {...getOverrideProps(overrides, "ResetButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={
              !(idProp || governanceDataModelProp) ||
              Object.values(errors).some((e) => e?.hasError)
            }
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
